module.exports = __webpack_public_path__ + "static/media/icon-trash-red.70daf5d6.svg";